export const getWebSocket = (state) => state.websocketServiceReducer.websocket;
export const getAttempts = (state) => state.websocketServiceReducer.attempts;
export const getError = (state) => state.websocketServiceReducer.error;
